import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { useInvalidate } from "@/lib/queries";

export function DeleteUniverse({ universe, onDeleted }) {
  const invalidate = useInvalidate();
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  const remove = async () => {
    setBusy(true);
    try {
      await api.delete(`/universes/${universe.id}`);
      invalidate(["universes"]);
      toast.success(`${universe.name} deleted`);
      onDeleted();
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(false);
    }
  };
  return (
    <section className="rounded-md border border-red-500/40 bg-red-500/5 p-6" data-testid="settings-danger-zone">
      <h2 className="font-display text-2xl text-red-300">Danger zone</h2>
      <p className="mt-1 mb-4 text-sm text-[#A8A090]">Deleting a universe permanently removes every entry, map, timeline and language in it. Type <b className="text-[#F3EBDD]">{universe.name}</b> to confirm.</p>
      <div className="flex flex-wrap gap-2">
        <Input value={typed} onChange={(e) => setTyped(e.target.value)} placeholder={universe.name} className="max-w-xs" data-testid="settings-delete-confirm-input" />
        <Button variant="destructive" disabled={busy || typed.trim() !== universe.name} onClick={remove} data-testid="settings-delete-button">{busy ? "Deleting…" : "Delete universe"}</Button>
      </div>
    </section>
  );
}
